import { render, staticRenderFns } from "./MediaUploadDialog.vue?vue&type=template&id=550e83c6&"
import script from "./MediaUploadDialog.vue?vue&type=script&lang=ts&"
export * from "./MediaUploadDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MediaUploadDialog.vue?vue&type=style&index=0&id=550e83c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports